import { Navigate, useNavigate } from "react-router-dom";

import { Login } from "../../features/login/Login";
import { PublicPage } from "../../components/pages/publicPage/PublicPage";
import { Routes } from "../../routes/Routes";
import styles from "./LoginPage.module.scss";
import { useSession } from "../../hooks/useSession";

/**
 * This page provides the possibility to login a user.
 */
export const LoginPage: React.FC = () => {
  const navigate = useNavigate();
  const session = useSession();

  if (session) {
    return <Navigate to={Routes.contracts.toPath()} />;
  }

  return (
    <PublicPage iconName="sign-in" showAnnouncement={false} showPageInfo={false}>
      <div className={styles.login}>
        <Login
          onLogin={(contract?: string, product?: string) => {
            if (contract && product) {
              navigate(
                Routes.contractProduct.toPath({
                  contractId: contract,
                  productId: product,
                })
              );
            } else {
              navigate(Routes.contracts.toPath());
            }
          }}
        />
      </div>
    </PublicPage>
  );
};
